export default __webpack_public_path__ + "static/logo-metaverse-454acbd93ebbff31f26dc5be9bcbc78c.png";